import { render, staticRenderFns } from "./SupervisorListTable.vue?vue&type=template&id=6959c028&scoped=true"
import script from "./SupervisorListTable.vue?vue&type=script&lang=js"
export * from "./SupervisorListTable.vue?vue&type=script&lang=js"
import style0 from "./SupervisorListTable.vue?vue&type=style&index=0&id=6959c028&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6959c028",
  null
  
)

export default component.exports